import { render, staticRenderFns } from "./CourierShippingRates.vue?vue&type=template&id=5a6d2c42&scoped=true"
import script from "./CourierShippingRates.vue?vue&type=script&lang=js"
export * from "./CourierShippingRates.vue?vue&type=script&lang=js"
import style0 from "./CourierShippingRates.vue?vue&type=style&index=0&id=5a6d2c42&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a6d2c42",
  null
  
)

export default component.exports